
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5989_21)"}},[_c('path',{attrs:{"fill":"#D97757","d":"m3.924 13.3 3.935-2.207.065-.193-.065-.108h-.194l-.66-.04-2.248-.06-1.946-.08-1.892-.1-.476-.1L0 9.818l.043-.29.4-.271.573.05 1.265.09 1.903.13 1.373.08L7.6 9.82h.324l.044-.13-.109-.08-.086-.08-1.968-1.334-2.13-1.405-1.113-.812-.594-.411-.303-.381-.13-.843.54-.602.736.05.184.05.746.572L5.33 5.647l2.075 1.525.303.25.122-.082.019-.058-.14-.23-1.125-2.037-1.2-2.076-.54-.863-.141-.511a2.3 2.3 0 0 1-.087-.612L5.232.11 5.578 0l.833.11.346.301.519 1.184.832 1.855 1.297 2.528.379.752.205.692.076.21h.13v-.12l.108-1.424.194-1.745.195-2.247.065-.632.313-.762.627-.411.487.23.4.572-.054.371-.238 1.545-.465 2.417-.303 1.625h.173l.206-.21.821-1.084 1.373-1.725.606-.682.713-.752.454-.361h.865l.627.943-.28.972-.887 1.124-.735.953-1.055 1.412-.654 1.135.059.094.158-.013 2.378-.512 1.286-.23 1.536-.261.692.32.075.332-.27.672-1.643.4-1.925.392-2.865.675-.032.025.038.056 1.292.116.551.03h1.351l2.52.191.659.431.389.532-.065.411-1.016.512-1.362-.321-3.19-.762-1.091-.271h-.152v.09l.908.893 1.676 1.504 2.087 1.946.108.482-.27.38-.282-.04-1.837-1.384-.714-.621-1.6-1.354h-.108v.14l.367.541 1.957 2.94.098.902-.141.29-.508.181-.552-.1-1.156-1.615-1.179-1.805-.951-1.625-.115.073-.566 6.045-.26.311-.605.231-.508-.381-.27-.622.27-1.234.324-1.605.26-1.273.238-1.585.145-.53-.013-.035-.116.02-1.195 1.638L6.8 16.851l-1.438 1.534-.346.14-.594-.31.054-.552.335-.491L6.8 14.644 8 13.069l.773-.904-.007-.13-.043-.004-5.285 3.445-.94.12-.412-.38.055-.622.194-.2z"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_5989_21"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    